import axios from "../axiosConfig";

class InvoiceRoutes {
  createInvoice = (payload) => {
    return axios.post("/api/invoices", payload);
  };

  getAllInvoices = () => {
    return axios.get("/api/invoices");
  };

  getInvoiceById = (id) => {
    return axios.get(`/api/invoices/${id}`);
  };

  getProjectData = (projectId) => {
    return axios.get(`/api/invoices/data/${projectId}`);
  };

  updateInvoice = (id, payload) => {
    return axios.put(`/api/invoices/${id}`, payload);
  };

  getNextInvoiceNumber = () => {
    return axios.get("/api/invoices/next-number");
  };

  deleteInvoice = (id) => {
    return axios.delete(`/api/invoices/${id}`);
  };
}

export default new InvoiceRoutes();

